const ProcessStepData01 = [
    {
        icon: "line-icon-Idea-5",
        title: "Project Research",
        content: "Lorem ipsum is simply dummy text the printing industry",
    },
    {
        icon: "line-icon-Fountain-Pen",
        title: "Design Sketches",
        content: "Lorem ipsum is simply dummy text the printing industry",
    },
    {
        icon: "line-icon-Loading-2",
        title: "Selected Concept",
        content: "Lorem ipsum is simply dummy text the printing industry",
    },
    {
        icon: "line-icon-Juice",
        title: "Client Presentation",
        content: "Lorem ipsum is simply dummy text the printing industry",
    },
]

const ourMission = [
    {
        content: "Promoting climate-resilient and sustainable production practices",
    },
    {
        content: "Supporting Farmer Producer Organizations (FPOs), agri-MSMEs, startups, and agribusiness players to strengthen entrepreneurship and rural livelihoods",
    },
    {
        content: "Developing infrastructure for storage, processing, and market access, including agri-parks, logistics hubs, and value addition centers",
    }
    ,
    {
        content: "Harnessing innovation, research, and digital technologies to drive efficiency, traceability, and adaptation",
    }
    ,
    {
        content: "Enhancing institutional capacity and fostering multi-departmental convergence to create a coordinated and investment-friendly agricultural environment",
    }
]

const keyComponents = [
    {
        icon: 'feather-arrow-right-circle',
        content: "Climate Resilience in Agriculture",
    },
    {
        icon: 'feather-arrow-right-circle',
        content: "Enhancing Small-holder Commercialization for Value Addition",
    },
    {
        icon: 'feather-arrow-right-circle',
        content: "Strengthening Agribusiness and the Food System",
    },
    {
        icon: 'feather-arrow-right-circle',
        content: "Project Management",
    },
]

const ProcessStepData04 = [
    {
        title: "RESEARCH PROJECT",
        content: "Lorem ipsum dolor consectetur adipiscing eiusmod tempor",
    },
    {
        title: "FIND PROBLEM",
        content: "Lorem ipsum dolor consectetur adipiscing eiusmod tempor",
    },
    {
        title: "START OPTIMIZE",
        content: "Lorem ipsum dolor consectetur adipiscing eiusmod tempor",
    },
    {
        title: "REACH TARGET",
        content: "Lorem ipsum dolor consectetur adipiscing eiusmod tempor",
    },
]

const ProcessStepData05 = [
    {
        title: "Start market research",
        content: "Lorem ipsum is simply text of the printing and typesetting industry lorem ipsum",
    },
    {
        title: "Discussion of the idea",
        content: "Lorem ipsum is simply text of the printing and typesetting industry lorem ipsum",
    },
    {
        title: "Production planning",
        content: "Lorem ipsum is simply text of the printing and typesetting industry lorem ipsum",
    }
]

const ProcessStepData06 = [
    {
        title: "Innovative business",
        content: "Easy to customize",
    },
    {
        title: "Expertly marketing",
        content: "High quality services",
    },
    {
        title: "Engaging audiences",
        content: "Build perfect websites",
    }
]


export { ProcessStepData01, keyComponents, ourMission, ProcessStepData04, ProcessStepData05, ProcessStepData06 }